import { createContext, useContext, useState } from "react"

interface IDateRangeFilterProviderContext {
    start:Date
    end:Date
    setStart:(date:Date)=>void
    setEnd:(date:Date)=>void
}
const DateRangeFilterProviderContext = createContext<IDateRangeFilterProviderContext>({} as any)
const useDateRangeFilter = () => useContext(DateRangeFilterProviderContext)

export default useDateRangeFilter

export function DateRangeFilterProvider(props:{children:any}) {
    const now = new Date()
    const [start,setStart] = useState<Date>(new Date(2000, 0, 1))
    const [end,setEnd] = useState<Date>(new Date(now.setDate(now.getDate()+1)))
    return <DateRangeFilterProviderContext.Provider value={{start,end,setStart,setEnd}}>{props.children}</DateRangeFilterProviderContext.Provider>
}